// extracted by mini-css-extract-plugin
export default {"container":"style_container__uQu7d","innerBox":"style_innerBox__j9bNF","disc":"style_disc__RgB3a"};